// Where the Depth API is (SERVER.md). Built in at build time (VITE_DEPTH_API_URL, default production). For local
// development a page can be opened with ?api=http://127.0.0.1:8800 — only loopback servers are accepted, so a link
// can never send someone's Google sign-in to another server. The choice is remembered for the tab (sessionStorage).

export const PRODUCTION_API = "https://api.readdepth.app";
export const GOOGLE_CLIENT_ID = "662691016970-18et591mu3t3elbendbi305eh23vaibm.apps.googleusercontent.com";

export function normalized(s: string): string {
  let b = s.trim();
  if (!b.includes("://")) b = "https://" + b;
  return b.replace(/\/+$/, "");
}

export function isLoopback(url: string): boolean {
  try {
    const u = new URL(url);
    return (u.protocol === "http:" || u.protocol === "https:") && ["127.0.0.1", "localhost", "[::1]"].includes(u.hostname);
  } catch {
    return false;
  }
}

function overrideFromPage(): string | null {
  if (typeof location === "undefined") return null;
  const q = new URLSearchParams(location.search).get("api");
  try {
    if (q !== null) {
      if (q === "" || q === "default") { sessionStorage.removeItem("depth.api"); return null; }
      if (isLoopback(normalized(q))) { sessionStorage.setItem("depth.api", normalized(q)); return normalized(q); }
      return null;
    }
    const kept = sessionStorage.getItem("depth.api");
    return kept && isLoopback(kept) ? kept : null;
  } catch {
    return null;
  }
}

export const API_BASE: string = overrideFromPage() ?? normalized(typeof __DEPTH_API_URL__ === "string" ? __DEPTH_API_URL__ : PRODUCTION_API);
export const IS_PRODUCTION_API = (() => { try { return new URL(API_BASE).host === new URL(PRODUCTION_API).host; } catch { return false; } })();
